import { render, staticRenderFns } from "./FotterComponent.vue?vue&type=template&id=663c15a2&"
import script from "./FotterComponent.vue?vue&type=script&lang=js&"
export * from "./FotterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports